import React from "react";
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';

const Index = () => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Type',
      attr: 'type',
    },
    {
      ...defaultHeaderConfig,
      label: 'Number of Batteries',
      attr: 'no_of_batteries',
      disableSort: true
    },
  ]

  return <ListingPageComponent
    key={PAGES.VehicleTypesListingPage.name}
    uiPage={uiManager.getUiPage(PAGES.VehicleTypesListingPage.name)}
    breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Vehicle Types'}]}
    listingMutation={getApi('vehicleTypes')}
    className="vehicle-types-listing-page"
    contentHeading="Vehicle Types List - Results"
    headers={headers}
    recordsKey="vehicle_types"
    searchBy={['Type']}
  />
};

export default Index;
